import { Matrix } from '@livecontrol/scheduler/components';
import React from 'react';

import S = Matrix.Stack;
import Card = S.Card;

interface Props {
  routers: {
    id: string;
    name?: string;
    status?: string;
  }[];
}

export const RouterStack = ({ routers }: Props): React.ReactElement => (
  <S>
    {routers
      .map(
        (router): React.ReactElement => (
          <Card key={router.id}>
            <Card.Body>
              <Card.Row label='Name'>{router.name ?? ''}</Card.Row>
              <Card.Row label='Status'>{router.status ?? ''}</Card.Row>
            </Card.Body>
          </Card>
        )
      )}
  </S>
);
